import React, { useState, useEffect } from "react";
//import { useSelector } from "react-redux";
import SVGIcon from "../../svgIcon/SVGIcon";

const VideoPlayer = (props) => {
  //const themeName = useSelector((state) => state.theme.program);
  const video = React.createRef();
  // const progress = React.createRef();
  const [isPlaying, setIsplaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    document.getElementById("volume-control").value = 100;
    document.getElementById("video-progress").value = 0;
  }, []);

  useEffect(() => {
    if (props.addVideoUserActivityLog)
      props.addVideoUserActivityLog();
    if (props.isPlaying) {
      setIsplaying(false);

      playPause();
    }
  }, []);


  const playPause = () => {
    if (!isPlaying) {
      video.current.play();
      updateProgress(video.current);
      setIsplaying(true);
    } else {
      video.current.pause();
      setIsplaying(false);
    }
  };

  const alterVolume = () => {
    video.current.muted = !video.current.muted;
    setIsMuted(!isMuted);
  };

  var checkVolume = function (item) {
    let valume = item.target.value;
    video.current.volume = parseInt(valume) / 100;
    if (valume == 0) {
      video.current.muted = true;
      setIsMuted(true);
    } else {
      video.current.muted = false;
      setIsMuted(false);
    }
    const volumeControl = document.getElementById("volume-control");
    volumeControl.style.backgroundSize = parseInt(valume) + "% 100%";
  };

  const updateProgress = (video) => {
    let timer = null;
    const progress = document.getElementById("video-progress");
    // progress.max = parseInt(video.duration / 60, 10) + "." + parseInt(video.duration % 60, 10);
    const totalDuration = document.getElementById("total-duration");
    const currentDuration = document.getElementById("current-time");

    timer = setInterval(function () {
      totalDuration.innerHTML = parseInt(video.duration / 60, 10) + ":" + (parseInt(video.duration % 60, 10) < 10
        ? "0" + parseInt(video.duration % 60, 10)
        : parseInt(video.duration % 60, 10));

      let progressValue = video.currentTime / video.duration;
      if (progress) {
        progress.value = progressValue * progress.max;
        let tempDur =
          parseInt(video.currentTime % 60, 10) < 10
            ? "0" + parseInt(video.currentTime % 60, 10)
            : parseInt(video.currentTime % 60, 10);

        currentDuration.innerHTML = parseInt(video.currentTime / 60, 10) + ":" + tempDur;
        progress.style.backgroundSize = (progressValue * 100) + "% 100%";
      }

      if (video.paused || progressValue >= 100) {
        clearInterval(timer);
      }
    }, 100);
  };

  const updateTime = (e) => {
    let value = e.target.value / 100 * video.current.duration;
    video.current.currentTime = value;
  };


  //video url sanitize 
  return (
    <>
      <video
        width={props.width}
        ref={video}
        onClick={() => playPause()}
        onEnded={() => setIsplaying(false)}
        onPlay={() => setIsplaying(true)}
        onPause={() => setIsplaying(false)}
      >
        <source src={new URL(props.src)} type={props.type} />
      </video>
      {!isPlaying && (
        <div className="big-play" onClick={() => playPause()}>
          <SVGIcon name={`icons/Play`} size="10" />
        </div>
      )}
      <div id="video-controls" className="controls" data-state="hidden">
        <input type="range" id="video-progress" className="video-progress" step="0.01" min="0.0" max="100" onChange={(e) => updateTime(e)} />

        <div className="control">
          <div className="d-flex">
            <div
              id="playpause"
              className="active mr-4 button"
              onClick={() => playPause()}
            >
              {isPlaying ? (
                <SVGIcon name={`icons/Pause`} size="10" />
              ) : (
                <SVGIcon name={`icons/Play`} size="10" />
              )}
            </div>
            <div className="divider"></div>
            <div className="volume">
              <div onClick={() => alterVolume()} className="button">
                {isMuted ? (
                  <SVGIcon name={`icons/VolumeMute`} size="10" />
                ) : (
                  <SVGIcon name={`icons/Volume`} size="10" />
                )}
              </div>
              <input
                type="range"
                id="volume-control"
                className="volume-change"
                onChange={(item) => checkVolume(item)}
              />
            </div>
          </div>
          <div className="d-flex align-items-center">
            <div className="mr-2">
              <span id="current-time">00:00</span> /{" "}
              <span id="total-duration">00:00</span>
            </div>
            <div
              onClick={() => video.current.requestFullscreen()}
              className="button"
            >
              <SVGIcon name={`icons/Fullscreen`} size="10" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoPlayer;
